<template>
  <article id="policy-details-insured-person" data-test-policy-insured-person-section>
    <h2 data-test-policy-policy-information-label v-text="modelValue.PolicyInformationTitle" />

    <field
      :modelValue="modelValue.InsurancePeriod"
      name="policy-details-insurance-period"
      data-test-policy-insured-information-insurance-period
    />

    <field
      :modelValue="modelValue.Name"
      name="name"
      data-test-policy-insured-information-policy-holder-name
    />

    <field
      :modelValue="modelValue.PolicyNumber"
      name="policy-number"
      data-test-policy-insured-information-policy-number
    />

    <field
      :modelValue="modelValue.MemberNumber"
      name="member-number"
      data-test-policy-insured-information-member-number
    />

    <field
      v-if="modelValue.ShowPrimaryUser"
      :modelValue="modelValue.PrimaryUser"
      name="primaryuser"
      data-test-policy-insured-information-primary-user
    />

    <template v-if="modelValue.ShowAdditionalUsers">
      <field
        v-for="(user, index) in modelValue.AdditionalUsers"
        :key="'additional-user-' + index"
        :modelValue="modelValue.AdditionalUsers[index]"
        data-test-policy-additional-user
      />
    </template>

    <field
      v-if="modelValue.ShowBonusLevel"
      :modelValue="modelValue.BonusLevel"
      name="bonusLevel"
      data-test-policy-insured-information-bonus-level
    />

    <field
      v-if="modelValue.ShowStudentFields"
      :modelValue="modelValue.IsStudent"
      name="isstudent"
      data-test-policy-insured-information-is-student
    />

    <field
      v-if="modelValue.ShowStudentFields"
      :modelValue="modelValue.StudentUntil"
      name="studentuntil"
      data-test-policy-insured-information-student-until
    />

    <field
      v-if="modelValue.IsHiredInLB"
      :modelValue="modelValue.IsHiredInLB"
      name="hired-in-lb"
      data-test-policy-insured-information-ishiredinlb
    />
  </article>
</template>

<script>
import Field from './Field.vue';

export default {
  name: 'PolicyInformation',
  components: {
    Field
  },
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  }
};
</script>
